import FormatDate from '@/helpers/FormatDate';
import { EFavoriteType } from '.';
import { EUserStatus } from '..';
//@ts-ignore
import _ from 'lodash'
import { UserLeaveGroupChat } from '../Chat';
import { handleTruncateContent } from '@/helpers/Common';
export class Favorite {
  id!: number
  group_id!: number
  favorite_target_type!: EFavoriteType;
  is_belong_to_group!: boolean
  is_my_calendar!: boolean
  is_topic_comment!: boolean // is this update is topic updatate or topic comment
  topic_comment_id!: number //for topic
  group_avatar: string[] = []   //group icon or group avatar of chat
  title: string = ''
  content: string = ''
  content_text: string = ''
  is_read!: boolean
  name: string = '' //file name or chatbox name
  only_user_chat: boolean = false // for chat
  path: string = '' //file path
  user_name: string = '' ///updater username
  avatar: string = '' //updater avatar
  updated_date: string = ''
  allow_anonymous_comment: boolean = false
  emergency_contact: boolean = false //is favorite topic is emergency contact
  event_start_date: string = ''//for schedule
  event_end_date: string = ''//for schedule
  user_active_status: EUserStatus = EUserStatus.NORMAL
  user_leave_chat!: UserLeaveGroupChat //for chat
  isTranslated: boolean = false
  translatedText: string = ''
  translatedTitle: string = ''
  hide_administrator?: boolean = false

  constructor(init?: Partial<Favorite>, className?: string) {
    Object.assign(this, init)

    if (this.favorite_target_type === EFavoriteType.COMMON_TOPIC && this.is_belong_to_group) {
      this.favorite_target_type = EFavoriteType.GROUP_TOPIC
    }

    if (this.favorite_target_type === EFavoriteType.COMMON_FILE && this.is_belong_to_group) {
      this.favorite_target_type = EFavoriteType.GROUP_FILE
    }

    if (this.favorite_target_type === EFavoriteType.CALENDAR) {
      this.content = `${FormatDate.formatEnWitdJaDay(this.event_start_date)} ～ ${FormatDate.formatEnWitdJaDay(this.event_end_date)}`
    }

    if (this.content) {
      this.content = handleTruncateContent(this.content)
    }

    if (this.content_text) {
      this.content_text = handleTruncateContent(this.content_text)
    }
  }
}

